import { useId, type SelectHTMLAttributes } from 'react';

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'id'> {
  label: string;
  options: { value: string; label: string }[];
  error?: string;
}

export function Select({ label, options, error, className, ...rest }: SelectProps) {
  const id = useId();
  return (
    <div className="ne-field">
      <label className="ne-field__label" htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className={['ne-input', error ? 'ne-input--error' : '', className]
          .filter(Boolean)
          .join(' ')}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        {...rest}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {error ? (
        <span id={`${id}-error`} className="ne-field__error" role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}
